import { render, staticRenderFns } from "./topRightcomplexTwo.vue?vue&type=template&id=13918c80&scoped=true"
import script from "./topRightcomplexTwo.vue?vue&type=script&lang=js"
export * from "./topRightcomplexTwo.vue?vue&type=script&lang=js"
import style0 from "./topRightcomplexTwo.vue?vue&type=style&index=0&id=13918c80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13918c80",
  null
  
)

export default component.exports